package fr.frux.feature.site

import fr.frux.feature.site.resources.Res
import fr.frux.feature.site.resources.site_count_few
import fr.frux.feature.site.resources.site_count_many
import fr.frux.feature.site.resources.site_count_one
import fr.frux.feature.site.resources.site_count_some
import fr.frux.feature.site.resources.site_rule_ask
import fr.frux.feature.site.resources.site_rule_open
import fr.frux.feature.site.resources.site_rule_private
import fr.frux.shared.domain.model.PlantingCount
import fr.frux.shared.domain.model.SiteAccessRule
import org.jetbrains.compose.resources.StringResource

fun SiteAccessRule.labelRes(): StringResource =
    when (this) {
        SiteAccessRule.OPEN -> Res.string.site_rule_open
        SiteAccessRule.ASK -> Res.string.site_rule_ask
        SiteAccessRule.PRIVATE -> Res.string.site_rule_private
    }

/** Une tranche, jamais un compte : « 2 à 5 » se lit comme un ordre de grandeur. */
fun PlantingCount.labelRes(): StringResource =
    when (this) {
        PlantingCount.ONE -> Res.string.site_count_one
        PlantingCount.FEW -> Res.string.site_count_few
        PlantingCount.SOME -> Res.string.site_count_some
        PlantingCount.MANY -> Res.string.site_count_many
    }
